import React, { Component } from "react";

import JubileeLists from "../elements/JubileeLists";
import MentionLists from "../elements/MentionLists";
import Log from "../elements/Log";

class Frontpage extends Component {
  render() {
    return (
      <div className="main-container">
        <div className="grid-x">
          <div className="medium-9 cell">
            <div className="primary-content">
              <div className="inner">
                <MentionLists
                  searchParams={this.props.searchParams}
                  Params={this.props.Params}
                  Type="mention"
                  Title="Omtale"
                />
                <MentionLists
                  searchParams={this.props.searchParams}
                  Params={this.props.Params}
                  Type="fleng"
                  Title="Fødselsdager"
                />
                <JubileeLists />
              </div>
            </div>
          </div>
          <div className="medium-3 cell">
            <div className="sidebar-holder">
              <Log category="deathchecker" title="Siste varsler" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Frontpage;
